import { Fragment, useEffect, useState } from 'react';
import history from 'utils/history';
import { Dialog, Transition } from '@headlessui/react';
import ConfigurationSection from '../ConfigurationSecton/index';
import Typography from 'components/Atoms/Typography';
import { Path } from 'constants/routes';
import { sendAmplitudeEvents } from 'utils/common';
import { EventNames } from 'utils/events';
import { useDispatch } from 'react-redux';

import './index.css';
import { showJobListAfterQuickRun } from 'store/actions/onboarding';

const TOOL_TIP_TEXT = 'Click here to view the results of your test';
const CustomTooltip = ({ text }) => {
  return <div className="custom-tooltip">{text}</div>;
};

const QuickRunFooter = ({
  allStepsCompleted,
  currentConfiguration,
  resetTestStatus,
  showGoToDashBoard,
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsopen] = useState(false);
  const [animationCircle, setAnimationCircle] = useState(0);

  function handleGoToDashBoardClick() {
    dispatch(showJobListAfterQuickRun(true));
    history.push(Path.JOBS);
    sendAmplitudeEvents(EventNames.HYP_ONBOARDING_DASHBOARD_BUTTON_CLICK, {
      'testing framework': currentConfiguration?.frameworkType,
      language: currentConfiguration?.framework?.language,
      framework: currentConfiguration?.framework?.name,
    });
    resetTestStatus();
  }

  useEffect(() => {
    // if all steps are completed we are showing animation of 3 circles, thats why adding the following timeouts
    if (allStepsCompleted) {
      setIsopen(true);
      window.setTimeout(() => {
        setIsopen(false);
      }, 4000);
      window.setTimeout(() => {
        setAnimationCircle((current) => current + 1);
      }, 1000);
      window.setTimeout(() => {
        setAnimationCircle((current) => current + 1);
      }, 2000);
    }
  }, [allStepsCompleted]);
  return (
    <>
      <ConfigurationSection
        classname={`go-to-dashboard-section ${
          showGoToDashBoard
            ? 'go-to-dashboard-section-visible'
            : 'go-to-dashboard-section-hidden'
        }`}
      >
        <>
          <div className="quick-run-content-heading">
            View your test results
          </div>
          <Typography variant="subtext-1" color="ltw-text-gray-4">
            Test results will be available on the dashboard after tests are
            triggered
          </Typography>
          <div className="go-to-dashboard-button-container">
            <button
              className={`go-to-dashboard-button ${
                allStepsCompleted
                  ? 'go-to-dashboard-button-active'
                  : 'go-to-dashboard-button-disabled'
              }`}
              onClick={handleGoToDashBoardClick}
            >
              Go to dashboard
            </button>
            {!!allStepsCompleted && (
              <>
                <CustomTooltip text={TOOL_TIP_TEXT} />
                {animationCircle >= 0 && (
                  <div className="animation-circle animation-circle-one"></div>
                )}
                {animationCircle >= 1 && (
                  <div className="animation-circle animation-circle-two"></div>
                )}
                {animationCircle >= 2 && (
                  <div className="animation-circle animation-circle-three"></div>
                )}
              </>
            )}
          </div>
        </>
      </ConfigurationSection>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog open={isOpen} onClose={() => setIsopen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="ltw-fixed ltw-inset-0 ltw-bg-black-darkest ltw-opacity-60" />
          </Transition.Child>
        </Dialog>
      </Transition>
    </>
  );
};

export default QuickRunFooter;
